// Avatar initials: first letters of the first and last word of the name, else
// the first two characters of the name or email. Splits on any whitespace run
// and drops empties, so a stored "Alex Tidgård " gives "AT", not "AUNDEFINED".
export function initials(name: string | null | undefined, email = ""): string {
  const words = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (words.length > 1) return (Array.from(words[0])[0] + Array.from(words[words.length - 1])[0]).toUpperCase();
  return Array.from(words[0] ?? email.trim()).slice(0, 2).join("").toUpperCase() || "?";
}
